import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import { Body, Box, Button, H6, red, black } from 'dma-ui-kit';
import { translateInterfaceText } from 'helpers/translation';

// Third-party ticketing (Etix) lives offsite, so instead of sending the visitor
// straight there the button first shows a notice explaining where the link
// goes. "Continue" opens the destination in a new tab; "Cancel" just closes.

const modalStyle = {
    content: {
        bottom: 'auto',
        left: '50%',
        maxWidth: '520px',
        padding: '24px',
        right: 'auto',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'calc(100% - 48px)'
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: '99'
    }
};

const Actions = styled(Box)`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 20px;
`;

const ExternalLinkButton = ({ href, label, siteName = 'Etix', variant = 'outline', compact = true, color = red }) => {
    const [isOpen, setIsOpen] = React.useState(false);

    const heading = translateInterfaceText('You are leaving the DMA\'s website.');
    const notice = translateInterfaceText('The linked site is operated by {siteName}. Please review its privacy policy to understand how your information is processed.')
        .replace('{siteName}', siteName);
    const continueLabel = translateInterfaceText('Continue');
    const cancelLabel = translateInterfaceText('Cancel');

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    const followLink = () => {
        window.open(href, '_blank', 'noopener,noreferrer');
        closeModal();
    };

    return (
        <>
            <Button
                label={label}
                variant={variant}
                compact={compact}
                color={color}
                onClick={openModal}
            />
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                style={modalStyle}
                contentLabel={heading}
                appElement={document.getElementById('root')}
            >
                <H6>{heading}</H6>
                <Box mt={'10px'}>
                    <Body variant="small">{notice}</Body>
                </Box>
                <Actions>
                    <Button
                        label={cancelLabel}
                        variant={'outline'}
                        compact={true}
                        color={red}
                        onClick={closeModal}
                    />
                    <Button
                        label={continueLabel}
                        variant={'outline'}
                        compact={true}
                        color={black}
                        onClick={followLink}
                    />
                </Actions>
            </Modal>
        </>
    );
};

export default ExternalLinkButton;
